import { type TranslationTree } from '@/i18n/types';

export const messages = {
  error: 'Não foi possível redefinir a senha, tente novamente',
} satisfies TranslationTree;
